import { getFullName } from '@provision/formatting-utils';
import { CommunicationChannel } from 'src/graphql/entities/user-communication-preferences';
import { PlatformUserRaw } from 'src/types';
import { sortAlphabetically } from 'src/utils/sorting';
import { appendDisabledUserTextToName } from './utils';

export function mapPlatformUserToOptions(user: PlatformUserRaw) {
  return {
    id: user.userId,
    partnerId: user.partnerId,
    value: user.userId,
    label: user.isActive ? getFullName(user) : appendDisabledUserTextToName(getFullName(user)),
    conversationAssigneeGroups: user.conversationAssigneeGroups ?? [],
    firstName: user.firstName,
    lastName: user.lastName,
    userGroups: user.userGroups,
    email: user.email,
    isActive: user.isActive,
    phoneNumber: user.phoneNumber,
    avatarFileKey: user.avatarFileKey,
    userCommunicationPreferences: (user.userCommunicationPreferences ?? [])
      .toSorted((a, b) => b.priority - a.priority)
      .map((item) => ({
        ...item,
        communicationChannel: item.communicationChannel as CommunicationChannel,
      }))
      .sort((a, b) => b.priority - a.priority),
  };
}

export function mapPlatformUsersToSortedOptions(users?: PlatformUserRaw[] | null) {
  return users?.map(mapPlatformUserToOptions).sort(sortAlphabetically('label'));
}
